export const JOKERS = [
    {
        id: 1,
        name: "Chẻ Bài"
    },
    {
        id: 2,
        name: "Trộm Bài"
    },
    {
        id: 3,
        name: "Hoán Vị Bài"
    },
    {
        id: 4,
        name: "Cắt Bài Giả(Múa Bài)"
    },
    {
        id: 5,
        name: "Đánh Dấu Bài"
    },
    {
        id: 6,
        name: "Kinh Bài"
    },
    {
        id: 7,
        name: "Phong Bài"
    },
    {
        id: 8,
        name: "Xào Bài Một lá"
    },
    {
        id: 9,
        name: "Cắt Bài Một Tay"
    },
    {
        id: 10,
        name: "Múa Một Lá Bài"
    },
    {
        id: 11,
        name: "Dấu Lá Bài"
    },
    {
        id: 12,
        name: "Kinh Bài Giả"
    },
    {
        id: 13,
        name: "Thấu Thị Bài"
    },
    {
        id: 14,
        name: "Định Vị Lá Bài"
    },
    {
        id: 15,
        name: "Xòe Bài"
    },
    {
        id: 16,
        name: "Xào Bài Giả"
    },
    {
        id: 17,
        name: "Chia Dưới"
    },
    {
        id: 18,
        name: "Lá Bài Double"
    },
    {
        id: 19,
        name: "Tham Chiếu Bài"
    },
    {
        id: 20,
        name: "Kẹp Bài Trên Dưới"
    },
    {
        id: 21,
        name: "Chia Bài Giữ Nút Trên"
    },
    {
        id: 22,
        name: "Gom Bài",
    },
    {
        id: 23,
        name: "Bắn Lá Bài"
    },
    {
        id: 24,
        name: "4/3(Công Thức 2 Lá)",
        concept: "1 Trên 1 Dưới Đáy"
    },
    {
        id: 25,
        name: "5/3(Công Thức 2 Lá)",
        concept: "2 Trên 0 Dưới Đáy"
    },
    {
        id: 26,
        name: "3/2/3(Công Thức 2 Lá)",
        concept: "0 Trên 2 Dưới"
    },
    {
        id: 27,
        name: "1/5/3(Công Thức 3 Lá)",
        concept: "3 Trên 0 Dưới"
    },
    {
        id: 28,
        name: "4/1/4(Công Thức 3 Lá)",
        concept: "0 Trên 3 Dưới"
    },
    {
        id: 29,
        name: "6/3(Công Thức 3 Lá)",
        concept: "2 Trên 1 Dưới"
    },
    {
        id: 30,
        name: "5/4(Công Thức 3 Lá)",
        concept: "1 Trên 2 Dưới"
    },
    {
        id: 31,
        name: "3/3(Công Thức 2/3/4 Lá)",
        concept: "Các Lá Bài Dưới Đáy Thì Sử Dụng Công Thức Này"
    },
    {
        id: 32,
        name: "4/1/5/3(Công Thức 4 Lá)",
        concept: "0 Trên 4 Dưới"
    },
    {
        id: 33,
        name: "4/3/3/3(Công Thức 4 Lá)",
        concept: "4 Trên 0 Dưới(Nếu Mà: 4 Dưới Đáy Thì Công Thức Sẽ Là 3/3/3)"
    },
    {
        id: 34,
        name: "5/5/3(Công Thức 4 Lá)",
        concept: "1 Trên 3 Dưới"
    },
    {
        id: 35,
        name: "1/5/4/3(Công Thức 4 Lá)",
        concept: "3 Trên 1 Dưới"
    },
    {
        id: 36,
        name: "6/4/3(Công Thức 4 Lá)",
        concept: "2 Trên 2 Dưới"
    }
]